export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.permissions': '权限管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.task': '任务管理',
  'menu.task.dashboard': '仪表盘',
  'menu.task.today': '今天',
  'menu.task.assignee': '我负责的',
  'menu.task.week': '本周',
  'menu.task.next7days': '未来7天',
  'menu.task.all': '全部任务',
  'menu.task.create': '我创建的',
  'menu.task.assigner': '我指派的',
  'menu.task.watched': '我关注的',
  'menu.task.completed': '已完成',
  'menu.task.recycle': '回收站',
  'menu.task.search': '搜索任务',
  'menu.task.active': '活动',
  'menu.task.report': '任务日报',
  'menu.task.screenAll': '所有大屏',
  'menu.task.screenDetail': '大屏详情',
  'menu.task.tasklists': '清单',
  'menu.task.tasklistDetail': '清单详情',
  'menu.task.tags': '标签',
  'menu.task.tagDetail': '标签详情',
  'menu.task.settings': '任务设置',
  'menu.task.settings.settingsNotification': '通知设置',
  'menu.task.settings.settingsRoles': '角色设置',
  'menu.task.settings.settingsPermissions': '权限设置',
  'menu.task.appConfig': '应用设置',
  'menu.task.appConfigMenu': '菜单配置',
  'menu.task.appConfigUpload': '上传配置',
  'menu.task.task.dashboard': '仪表盘',
  'menu.task.task.today': '今天',
  'menu.task.task.assignee': '我负责的',
  'menu.task.task.week': '本周',
  'menu.task.task.next7days': '未来7天',
  'menu.task.task.all': '全部任务',
  'menu.task.task.create': '我创建的',
  'menu.task.task.assigner': '我指派的',
  'menu.task.task.watched': '我关注的',
  'menu.task.task.completed': '已完成',
  'menu.task.task.recycle': '回收站',
  'menu.task.task.search': '搜索任务',
  'menu.task.task.active': '活动',
  'menu.task.task.report': '任务日报',
  'menu.task.task.screenAll': '所有大屏',
  'menu.task.task.screenDetail': '大屏详情',
  'menu.task.task.tasklists': '清单',
  'menu.task.task.tasklistDetail': '清单详情',
  'menu.task.task.tags': '标签',
  'menu.task.task.tagDetail': '标签详情',
  'menu.task.task.appConfig': '应用设置',
  'menu.task.appConfig.appConfigMenu': '菜单配置',
  'menu.task.appConfig.appConfigUpload': '上传配置',
  'menu.task.task.appConfig.task.appConfigMenu': '菜单配置',
  'menu.task.task.appConfig.task.appConfigUpload': '上传配置',
};
